import { Menu, MenuProps } from 'antd';
import styled from 'styled-components';

export const StyledMenu = styled((props: MenuProps) => <Menu {...props} />)`
  ${({ theme }) => `
    border-inline-end: 0 !important;
    & .ant-menu-item {
      display: flex;
      align-items: center;
    };

    & .ant-menu-item-divider {
      border-color: ${theme.Color.Neutrals.Border};
    }
  `}
`;
